import { Component, OnInit } from '@angular/core';
import { ContactService } from '../_services/contact.service';
import { ToasterService } from '../_services/toaster.service';
import { Title } from '@angular/platform-browser';
import { LoaderService } from '../_services/loader.service';
import { CanonicalService } from '../shared/canonical.service';
import { NiceScrollService } from '../_services/nice-scroll.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})
export class ContactComponent implements OnInit {

  public FullName: string;
  public EmailAddress: string;
  public PhoneNumber: number;
  public Subject: string;
  public Message: string;

  // map: google.maps.Map;
  // lat = 24.8607343;
  // lng = 67.0011364;
  // coordinates = new google.maps.LatLng(this.lat, this.lng);

  // mapOptions: google.maps.MapOptions = {
  //   center: this.coordinates,
  //   zoom: 12
  // };
  // marker = new google.maps.Marker({
  //   position: this.coordinates,
  //   map: this.map,
  //   title: 'Karachi'
  // });

  constructor(private titleService: Title,
              private contactService: ContactService,
              private tostrService: ToasterService,
              private loaderService: LoaderService,
              private canonicalService: CanonicalService ,
              private niceScroll: NiceScrollService
              ) {
                niceScroll.scrollToTop();
              }

  ngOnInit() {
    this.titleService.setTitle('Contact Us | Buy, Sell, Rent Homes & Properties in Pakistan | pakmatti.com');
    this.canonicalService.setCanonicalURL();
  }

  // tslint:disable-next-line: use-lifecycle-interface
  // ngAfterViewInit() {
  //   this.mapInitializer();
  // }

  // mapInitializer() {
  //   this.map = new google.maps.Map(document.getElementById('propertyMap'), this.mapOptions);
  //   this.marker.setMap(this.map);
  // }

  saveContact(contactForm: any) {
    this.loaderService.showLoader();
    this.contactService.ContactUs(contactForm.form.value).subscribe(response => {
      if (response.IsSuccess) {
        this.tostrService.Info(response.Message);
      } else {
        this.tostrService.Error('Something went wrong, try to come back later!');
      }
      this.loaderService.hideLoader();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
